{
    "jBlej": {
        "position": {
            "x": 1,
            "y": 23,
            "z": 1
        },
        "key": "jBlej",
        "tag": "badspawn"
    },
    "YcUWR": {
        "position": {
            "x": 2,
            "y": 23,
            "z": 1
        },
        "key": "YcUWR",
        "tag": "badspawn"
    },
    "hD02m": {
        "position": {
            "x": 3,
            "y": 23,
            "z": 1
        },
        "key": "hD02m",
        "tag": "badspawn"
    },
    "4847H": {
        "position": {
            "x": 4,
            "y": 24,
            "z": 1
        },
        "key": "4847H",
        "tag": "badspawn"
    },
    "TwIMr": {
        "position": {
            "x": 4,
            "y": 25,
            "z": 1
        },
        "key": "TwIMr",
        "tag": "badspawn"
    },
    "BpxI5": {
        "position": {
            "x": 4,
            "y": 26,
            "z": 1
        },
        "key": "BpxI5",
        "tag": "badspawn"
    },
    "aGjgu": {
        "position": {
            "x": 3,
            "y": 27,
            "z": 1
        },
        "key": "aGjgu",
        "tag": "badspawn"
    },
    "qF51x": {
        "position": {
            "x": 2,
            "y": 27,
            "z": 1
        },
        "key": "qF51x",
        "tag": "badspawn"
    },
    "zSV3S": {
        "position": {
            "x": 1,
            "y": 27,
            "z": 1
        },
        "key": "zSV3S",
        "tag": "badspawn"
    },
    "H0PS_": {
        "position": {
            "x": 2,
            "y": 24,
            "z": 1
        },
        "key": "H0PS_",
        "tag": "badspawn"
    },
    "auxmh": {
        "position": {
            "x": 2,
            "y": 26,
            "z": 1
        },
        "key": "auxmh",
        "tag": "badspawn"
    },
    "WyyY6": {
        "position": {
            "x": 3,
            "y": 25,
            "z": 1
        },
        "key": "WyyY6",
        "tag": "badspawn"
    },
    "bouIr": {
        "position": {
            "x": 0,
            "y": 25,
            "z": 1
        },
        "key": "bouIr",
        "tag": "goodspawn"
    },
    "V2nPH": {
        "position": {
            "x": 0,
            "y": 26,
            "z": 1
        },
        "key": "V2nPH",
        "tag": "goodspawn"
    },
    "HYLTR": {
        "position": {
            "x": 0,
            "y": 24,
            "z": 1
        },
        "key": "HYLTR",
        "tag": "goodspawn"
    },
    "gGoXq": {
        "position": {
            "x": 6,
            "y": 25,
            "z": 1
        },
        "key": "gGoXq",
        "tag": "goodspawn"
    },
    "7jLOy": {
        "position": {
            "x": 6,
            "y": 26,
            "z": 1
        },
        "key": "7jLOy",
        "tag": "goodspawn"
    },
    "mWJ2u": {
        "position": {
            "x": 6,
            "y": 24,
            "z": 1
        },
        "key": "mWJ2u",
        "tag": "goodspawn"
    },
    "Zx80n": {
        "position": {
            "x": 11,
            "y": 25,
            "z": 1
        },
        "key": "Zx80n",
        "tag": "goodspawn"
    },
    "s6ki8": {
        "position": {
            "x": 11,
            "y": 26,
            "z": 1
        },
        "key": "s6ki8",
        "tag": "goodspawn"
    },
    "QwYRe": {
        "position": {
            "x": 11,
            "y": 24,
            "z": 1
        },
        "key": "QwYRe",
        "tag": "goodspawn"
    },
    "o2zeG": {
        "position": {
            "x": 16,
            "y": 25,
            "z": 1
        },
        "key": "o2zeG",
        "tag": "goodspawn"
    },
    "rEnuh": {
        "position": {
            "x": 16,
            "y": 26,
            "z": 1
        },
        "key": "rEnuh",
        "tag": "goodspawn"
    },
    "sVXxS": {
        "position": {
            "x": 16,
            "y": 24,
            "z": 1
        },
        "key": "sVXxS",
        "tag": "goodspawn"
    },
    "AL_L6": {
        "position": {
            "x": 22,
            "y": 24,
            "z": 1
        },
        "key": "AL_L6",
        "tag": "goodspawn"
    },
    "Vx5RC": {
        "position": {
            "x": 22,
            "y": 25,
            "z": 1
        },
        "key": "Vx5RC",
        "tag": "goodspawn"
    },
    "vl6kK": {
        "position": {
            "x": 22,
            "y": 23,
            "z": 1
        },
        "key": "vl6kK",
        "tag": "goodspawn"
    },
    "iwkV0": {
        "position": {
            "x": 27,
            "y": 24,
            "z": 1
        },
        "key": "iwkV0",
        "tag": "goodspawn"
    },
    "fXnvk": {
        "position": {
            "x": 27,
            "y": 25,
            "z": 1
        },
        "key": "fXnvk",
        "tag": "goodspawn"
    },
    "GAG2y": {
        "position": {
            "x": 27,
            "y": 23,
            "z": 1
        },
        "key": "GAG2y",
        "tag": "goodspawn"
    },
    "wuDAm": {
        "position": {
            "x": 35,
            "y": 25,
            "z": 1
        },
        "key": "wuDAm",
        "tag": "goodspawn"
    },
    "3A02X": {
        "position": {
            "x": 35,
            "y": 26,
            "z": 1
        },
        "key": "3A02X",
        "tag": "goodspawn"
    },
    "r68-M": {
        "position": {
            "x": 35,
            "y": 24,
            "z": 1
        },
        "key": "r68-M",
        "tag": "goodspawn"
    },
    "kGXhc": {
        "position": {
            "x": 9,
            "y": 24,
            "z": 1
        },
        "key": "kGXhc",
        "tag": "badspawn"
    },
    "_bQOF": {
        "position": {
            "x": 9,
            "y": 25,
            "z": 1
        },
        "key": "_bQOF",
        "tag": "badspawn"
    },
    "x_3AY": {
        "position": {
            "x": 9,
            "y": 26,
            "z": 1
        },
        "key": "x_3AY",
        "tag": "badspawn"
    },
    "6uKZY": {
        "position": {
            "x": 7,
            "y": 23,
            "z": 1
        },
        "key": "6uKZY",
        "tag": "badspawn"
    },
    "Qvy-S": {
        "position": {
            "x": 8,
            "y": 23,
            "z": 1
        },
        "key": "Qvy-S",
        "tag": "badspawn"
    },
    "BIbLj": {
        "position": {
            "x": 8,
            "y": 27,
            "z": 1
        },
        "key": "BIbLj",
        "tag": "badspawn"
    },
    "zlKYV": {
        "position": {
            "x": 7,
            "y": 27,
            "z": 1
        },
        "key": "zlKYV",
        "tag": "badspawn"
    },
    "iif0v": {
        "position": {
            "x": 7,
            "y": 26,
            "z": 1
        },
        "key": "iif0v",
        "tag": "badspawn"
    },
    "H9w7Q": {
        "position": {
            "x": 8,
            "y": 25,
            "z": 1
        },
        "key": "H9w7Q",
        "tag": "badspawn"
    },
    "Wz5ge": {
        "position": {
            "x": 7,
            "y": 24,
            "z": 1
        },
        "key": "Wz5ge",
        "tag": "badspawn"
    },
    "E2MOP": {
        "position": {
            "x": 12,
            "y": 23,
            "z": 1
        },
        "key": "E2MOP",
        "tag": "badspawn"
    },
    "poUr9": {
        "position": {
            "x": 13,
            "y": 23,
            "z": 1
        },
        "key": "poUr9",
        "tag": "badspawn"
    },
    "gXWcX": {
        "position": {
            "x": 14,
            "y": 24,
            "z": 1
        },
        "key": "gXWcX",
        "tag": "badspawn"
    },
    "H7jcI": {
        "position": {
            "x": 14,
            "y": 25,
            "z": 1
        },
        "key": "H7jcI",
        "tag": "badspawn"
    },
    "-fvAc": {
        "position": {
            "x": 14,
            "y": 26,
            "z": 1
        },
        "key": "-fvAc",
        "tag": "badspawn"
    },
    "223oi": {
        "position": {
            "x": 13,
            "y": 25,
            "z": 1
        },
        "key": "223oi",
        "tag": "badspawn"
    },
    "_1ikP": {
        "position": {
            "x": 12,
            "y": 24,
            "z": 1
        },
        "key": "_1ikP",
        "tag": "badspawn"
    },
    "PQdz3": {
        "position": {
            "x": 12,
            "y": 26,
            "z": 1
        },
        "key": "PQdz3",
        "tag": "badspawn"
    },
    "SyS03": {
        "position": {
            "x": 17,
            "y": 23,
            "z": 1
        },
        "key": "SyS03",
        "tag": "badspawn"
    },
    "CJ8lp": {
        "position": {
            "x": 18,
            "y": 23,
            "z": 1
        },
        "key": "CJ8lp",
        "tag": "badspawn"
    },
    "Q607Y": {
        "position": {
            "x": 19,
            "y": 24,
            "z": 1
        },
        "key": "Q607Y",
        "tag": "badspawn"
    },
    "euVmy": {
        "position": {
            "x": 20,
            "y": 25,
            "z": 1
        },
        "key": "euVmy",
        "tag": "badspawn"
    },
    "6z0zr": {
        "position": {
            "x": 20,
            "y": 26,
            "z": 1
        },
        "key": "6z0zr",
        "tag": "badspawn"
    },
    "IIjWa": {
        "position": {
            "x": 20,
            "y": 27,
            "z": 1
        },
        "key": "IIjWa",
        "tag": "badspawn"
    },
    "B7g9B": {
        "position": {
            "x": 17,
            "y": 27,
            "z": 1
        },
        "key": "B7g9B",
        "tag": "badspawn"
    },
    "ngtwy": {
        "position": {
            "x": 18,
            "y": 27,
            "z": 1
        },
        "key": "ngtwy",
        "tag": "badspawn"
    },
    "tJeTu": {
        "position": {
            "x": 19,
            "y": 27,
            "z": 1
        },
        "key": "tJeTu",
        "tag": "badspawn"
    },
    "WvNlA": {
        "position": {
            "x": 17,
            "y": 24,
            "z": 1
        },
        "key": "WvNlA",
        "tag": "badspawn"
    },
    "aZW3P": {
        "position": {
            "x": 17,
            "y": 26,
            "z": 1
        },
        "key": "aZW3P",
        "tag": "badspawn"
    },
    "YOZxu": {
        "position": {
            "x": 19,
            "y": 26,
            "z": 1
        },
        "key": "YOZxu",
        "tag": "badspawn"
    },
    "tiGkc": {
        "position": {
            "x": 18,
            "y": 25,
            "z": 1
        },
        "key": "tiGkc",
        "tag": "badspawn"
    },
    "73rQo": {
        "position": {
            "x": 23,
            "y": 23,
            "z": 1
        },
        "key": "73rQo",
        "tag": "badspawn"
    },
    "wbgei": {
        "position": {
            "x": 24,
            "y": 23,
            "z": 1
        },
        "key": "wbgei",
        "tag": "badspawn"
    },
    "l-_rL": {
        "position": {
            "x": 25,
            "y": 24,
            "z": 1
        },
        "key": "l-_rL",
        "tag": "badspawn"
    },
    "6M8bd": {
        "position": {
            "x": 25,
            "y": 25,
            "z": 1
        },
        "key": "6M8bd",
        "tag": "badspawn"
    },
    "Ne4y9": {
        "position": {
            "x": 23,
            "y": 25,
            "z": 1
        },
        "key": "Ne4y9",
        "tag": "badspawn"
    },
    "eGKH0": {
        "position": {
            "x": 24,
            "y": 25,
            "z": 1
        },
        "key": "eGKH0",
        "tag": "badspawn"
    },
    "gp-Sy": {
        "position": {
            "x": 24,
            "y": 24,
            "z": 1
        },
        "key": "gp-Sy",
        "tag": "badspawn"
    },
    "xhEs6": {
        "position": {
            "x": 29,
            "y": 24,
            "z": 1
        },
        "key": "xhEs6",
        "tag": "badspawn"
    },
    "WtRUm": {
        "position": {
            "x": 28,
            "y": 23,
            "z": 1
        },
        "key": "WtRUm",
        "tag": "badspawn"
    },
    "RvWnL": {
        "position": {
            "x": 29,
            "y": 23,
            "z": 1
        },
        "key": "RvWnL",
        "tag": "badspawn"
    },
    "d8pS_": {
        "position": {
            "x": 29,
            "y": 25,
            "z": 1
        },
        "key": "d8pS_",
        "tag": "badspawn"
    },
    "4M5Ky": {
        "position": {
            "x": 28,
            "y": 25,
            "z": 1
        },
        "key": "4M5Ky",
        "tag": "badspawn"
    },
    "x_DLX": {
        "position": {
            "x": 32,
            "y": 26,
            "z": 1
        },
        "key": "x_DLX",
        "tag": "badspawn"
    },
    "94wFn": {
        "position": {
            "x": 33,
            "y": 26,
            "z": 1
        },
        "key": "94wFn",
        "tag": "badspawn"
    },
    "r686v": {
        "position": {
            "x": 33,
            "y": 25,
            "z": 1
        },
        "key": "r686v",
        "tag": "badspawn"
    },
    "pW1-K": {
        "position": {
            "x": 33,
            "y": 24,
            "z": 1
        },
        "key": "pW1-K",
        "tag": "badspawn"
    },
    "snKDF": {
        "position": {
            "x": 33,
            "y": 23,
            "z": 1
        },
        "key": "snKDF",
        "tag": "badspawn"
    },
    "MoC_x": {
        "position": {
            "x": 32,
            "y": 23,
            "z": 1
        },
        "key": "MoC_x",
        "tag": "badspawn"
    },
    "FBj4M": {
        "position": {
            "x": 36,
            "y": 23,
            "z": 1
        },
        "key": "FBj4M",
        "tag": "badspawn"
    },
    "oG8C7": {
        "position": {
            "x": 37,
            "y": 23,
            "z": 1
        },
        "key": "oG8C7",
        "tag": "badspawn"
    },
    "kvaMD": {
        "position": {
            "x": 37,
            "y": 24,
            "z": 1
        },
        "key": "kvaMD",
        "tag": "badspawn"
    },
    "u4oJp": {
        "position": {
            "x": 37,
            "y": 25,
            "z": 1
        },
        "key": "u4oJp",
        "tag": "badspawn"
    },
    "9styy": {
        "position": {
            "x": 37,
            "y": 27,
            "z": 1
        },
        "key": "9styy",
        "tag": "badspawn"
    },
    "mLfSS": {
        "position": {
            "x": 37,
            "y": 26,
            "z": 1
        },
        "key": "mLfSS",
        "tag": "badspawn"
    },
    "3VD2-": {
        "position": {
            "x": 36,
            "y": 27,
            "z": 1
        },
        "key": "3VD2-",
        "tag": "badspawn"
    },
    "-A8wt": {
        "position": {
            "x": 36,
            "y": 25,
            "z": 1
        },
        "key": "-A8wt",
        "tag": "badspawn"
    },
    "37jCP": {
        "position": {
            "x": 31,
            "y": 24,
            "z": 1
        },
        "key": "37jCP",
        "tag": "goodspawn"
    },
    "zBnrk": {
        "position": {
            "x": 31,
            "y": 25,
            "z": 1
        },
        "key": "zBnrk",
        "tag": "goodspawn"
    },
    "H5G-X": {
        "position": {
            "x": 31,
            "y": 23,
            "z": 1
        },
        "key": "H5G-X",
        "tag": "goodspawn"
    },
    "1CHNI": {
        "position": {
            "x": 2,
            "y": 25,
            "z": 1
        },
        "key": "1CHNI",
        "tag": "center"
    },
    "fbFby": {
        "position": {
            "x": 8,
            "y": 25,
            "z": 1
        },
        "key": "fbFby",
        "tag": "center"
    },
    "Le9PW": {
        "position": {
            "x": 12,
            "y": 25,
            "z": 1
        },
        "key": "Le9PW",
        "tag": "center"
    },
    "QCdVA": {
        "position": {
            "x": 18,
            "y": 25,
            "z": 1
        },
        "key": "QCdVA",
        "tag": "center"
    },
    "sjFIE": {
        "position": {
            "x": 23,
            "y": 24,
            "z": 1
        },
        "key": "sjFIE",
        "tag": "center"
    },
    "Uu2P4": {
        "position": {
            "x": 28,
            "y": 24,
            "z": 1
        },
        "key": "Uu2P4",
        "tag": "center"
    },
    "svj73": {
        "position": {
            "x": 32,
            "y": 25,
            "z": 1
        },
        "key": "svj73",
        "tag": "center"
    },
    "wrTgl": {
        "position": {
            "x": 36,
            "y": 25,
            "z": 1
        },
        "key": "wrTgl",
        "tag": "center"
    }
}